<div class="bg-{{ meta.color }}" *ngIf="!gig.isOwner">
  <div class="gigs-container titles-container" fxLayout="column" fxLayoutGap="20px">
    <h2 class="no-margin title" i18n>Slots</h2>
    <h3 class="no-margin sub-title" i18n *ngIf="!gig.limitedData">Select the slots you want to apply to</h3>
  </div>
</div>
